import React, { useCallback, useContext, useMemo } from 'react'
import moment from 'moment'
import DualDateRangePicker from 'components/Common/Calendar/DualDateRangePicker'
import DateRangePicker from 'components/Common/Calendar/DateRangePicker'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import { CALENDAR_GA_EVENT_ACTION } from 'constants/analytics'
import UserAnalyticsActionContext from 'contexts/userAnalyticsActionContext'
import { beginningOfToday } from 'lib/datetime/dateUtils'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { preventRenderWithClosedFilter } from 'lib/offer/offerPageUtil'

interface Props {
  checkInDate?: string;
  checkOutDate?: string;
  single?: boolean;
}

const today = beginningOfToday()

function OfferDatePicker({
  checkInDate,
  checkOutDate,
  single,
}: Props) {
  const dispatch = useOfferPageDispatch()
  const onUserAnalyticsAction = useContext(UserAnalyticsActionContext)

  const checkIn = useMemo(() => checkInDate ? moment(checkInDate) : undefined, [checkInDate])
  const checkOut = useMemo(() => checkOutDate ? moment(checkOutDate) : undefined, [checkOutDate])

  const onDatesChange = useCallback((dates: { startDate: moment.Moment; endDate?: moment.Moment | null; }) => {
    dispatch({ type: OfferPageActions.setCheckInDate, checkIn: dates.startDate.format(ISO_DATE_FORMAT) })
    dispatch({ type: OfferPageActions.setCheckOutDate, checkOut: dates.endDate?.format(ISO_DATE_FORMAT) ?? undefined })
    onUserAnalyticsAction?.(CALENDAR_GA_EVENT_ACTION.DateChanged)
  }, [dispatch, onUserAnalyticsAction])

  return (<div>
    {single && <DateRangePicker
      onDatesChange={onDatesChange}
      startDate={checkIn}
      endDate={checkOut}
      minDate={today}
      startLabel="Check in"
      endLabel="Check out"
    />}
    {!single &&
      <DualDateRangePicker
        onDatesChange={onDatesChange}
        startDate={checkIn}
        endDate={checkOut}
        minDate={today}
        startLabel="Check in"
        endLabel="Check out"
      />
    }
  </div>
  )
}

export default withOfferPageState(state => ({
  checkInDate: state.checkInDate,
  checkOutDate: state.checkOutDate,
  open: !!state.activeFilter || state.activeHeaderFilter === 'checkin',
}), OfferDatePicker, preventRenderWithClosedFilter)
